import { officialAccounts } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function AccountsSection() {
  return (
    <section className="bg-background-100 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <SectionHeading
            kicker="Official Accounts"
            title="官方账号一览"
            description="平台仅在以下账号发布内容与接收联络。任何未列出的账号、群组或私人联系方式，都不代表深瞳爆料。"
          />

          <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {officialAccounts.map((account) => (
              <div
                key={account.name}
                className="flex items-start gap-4 bg-background-50 border border-foreground-950/10 rounded-lg p-5 md:p-6 hover:border-accent-400 transition-colors"
              >
                <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-900">
                  <i className={`${account.icon} text-xl`}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {account.name}
                  </h3>
                  <p className="mt-1.5 font-mono text-xs text-primary-600 break-all">
                    {account.handle}
                  </p>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                    {account.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}